import React from 'react';
import AsyncSelect from 'react-select/async';
import MapboxClient from '@mapbox/mapbox-sdk';
import mbxGeocoder from '@mapbox/mapbox-sdk/services/geocoding';
import { WebMercatorViewport } from '@math.gl/web-mercator';
const formatFeature = feature => ({
    label: feature.place_name,
    bbox: feature.bbox,
    center: feature.center,
    id: feature.id,
    value: feature.id,
    feature: feature
});
/**
 * Allows searching of locations and zooming into that location or point of interest.
 * The geocoder uses the Mapbox API.
 */
const Geocoder = ({ className, accessToken, setViewport, apiOptions = {}, onSelect = () => null }) => {
    const geocoderService = mbxGeocoder(MapboxClient({ accessToken: accessToken }));
    const loadOptions = (inputValue, callback) => {
        if (inputValue) {
            geocoderService
                .forwardGeocode(Object.assign({ query: inputValue, limit: 5 }, apiOptions))
                .send()
                .then(response => callback(response.body.features.map(formatFeature)));
        }
        else {
            callback([]);
        }
    };
    return (React.createElement(AsyncSelect, { className: className, components: {
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null
        }, noOptionsMessage: () => null, loadOptions: loadOptions, defaultOptions: true, onChange: feature => {
            setViewport(viewport => {
                if (feature.bbox) {
                    const { longitude, latitude, zoom } = new WebMercatorViewport(viewport).fitBounds([feature.bbox.slice(0, 2), feature.bbox.slice(2, 4)]);
                    return Object.assign(Object.assign({}, viewport), { longitude,
                        latitude,
                        zoom });
                }
                else {
                    return Object.assign(Object.assign({}, viewport), { longitude: feature.center[0], latitude: feature.center[1], zoom: 15 });
                }
            });
            onSelect(feature.feature);
        } }));
};
export default Geocoder;
//# sourceMappingURL=Geocoder.js.map